import { Component, inject, OnInit } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import {
  CategoryItem,
  CategorySelectorComponent,
} from '../../../custom-input/category-selector/category-selector.component';
import { MealFormService } from 'src/app/trip-calculator/services/meal-form.service';
import { MealType } from 'src/app/trip-calculator/models/meal';

@Component({
  selector: 'app-select-meal-type',
  imports: [TranslocoPipe, CategorySelectorComponent],
  templateUrl: './select-meal-type.component.html',
})
export class SelectMealTypeComponent implements OnInit {
  mealFormService = inject(MealFormService);
  translocoService = inject(TranslocoService);
  typeList: CategoryItem[] = [];

  ngOnInit() {
    this.initializeTypeList();
  }

  initializeTypeList() {
    this.typeList = [];
    for (const type of Object.values(MealType)) {
      this.typeList.push({
        value: type,
        label: this.translocoService.translate('categoryType.' + type),
      });
    }
  }

  get type() {
    const type = this.mealFormService.mealForm.get('type')?.value;
    return type ? type : '';
  }

  set type(value) {
    this.mealFormService.mealForm.get('type')?.setValue(value);
  }
}
